import React__default from 'react';
import AvatarMUI from '../../../node_modules/@mui/material/Avatar/Avatar.js';

function stringToColor(string) {
    let hash = 0;
    let i;
    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = "#";
    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */
    return color;
}
function stringAvatar(name) {
    if (!name)
        return;
    const splitString = name.trim().split(" ");
    // Get the first character of the first word
    let result = splitString[0].charAt(0);
    // If there's more than one word, add the first character of the last word
    if (splitString.length > 1) {
        result += splitString[splitString.length - 1].charAt(0);
    }
    return {
        sx: {
            bgcolor: stringToColor(name),
        },
        children: result.toUpperCase(),
    };
}
const Avatar = (props) => {
    let sizePX = 40;
    if (props.size === "small")
        sizePX = 26;
    if (props.size === "large")
        sizePX = 54;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(AvatarMUI, { alt: props.altText, ...stringAvatar(props.altText), src: props.imageURL, sx: {
                width: sizePX,
                height: sizePX,
                fontSize: sizePX / 2.5,
                bgcolor: props.altText ? stringToColor(props.altText) : null,
            } })));
};

export { Avatar as default };
//# sourceMappingURL=Avatar.js.map
